module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "xl-main"
  }, [_c('div', {
    attrs: {
      "id": "xl-mahjong"
    }
  }, [_c('h2', [_vm._v("麻将游戏")]), _vm._v(" "), _c('h3', [_vm._v("文明游戏  ,  禁止赌博")]), _vm._v(" "), _c('ul', _vm._l((_vm.gameList), function(item, index) {
    return _c('li', {
      key: index
    }, [_c('a', {
      attrs: {
        "href": item.url
      }
    }, [_c('div', {
      staticClass: "list_img"
    }, [_c('img', {
      attrs: {
        "src": item.gameSrc
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "show"
    }, [_c('img', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.show),
        expression: "item.show"
      }],
      attrs: {
        "src": item.hot
      }
    })])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _vm._m(0, true)])])
  }), 0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', [_vm._v("下 载"), _c('img', {
    attrs: {
      "src": require("../images/xl_game_29.png")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-073baf31"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/Main.vue
// module id = 257
// module chunks = 1